import { merge } from 'rambda';

const select = (prev, next) => {
  const { id } = next;
  return merge(prev, { selectedId: id });
};

export default select;
